import {
  CUSTOMER_FIELD_FILTER_REQUEST,
  CUSTOMER_FIELD_FILTER_REQUEST_SUCCESS,
  CUSTOMER_FIELD_FILTER_REQUEST_FAILURE,
  CUSTOMER_FIELD_FILTER_CLEAN_REQUEST,
  CUSTOMER_ENROLLMENT_REPORT_FIELD_FILTER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const customerFilterFieldsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case CUSTOMER_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CUSTOMER_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case CUSTOMER_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CUSTOMER_FIELD_FILTER_CLEAN_REQUEST:
    case CUSTOMER_ENROLLMENT_REPORT_FIELD_FILTER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default customerFilterFieldsReducer;
